import { archetypeLightTheme } from '@leagueplatform/genesis-core';
import { customerSupportAppLocales } from '@leagueplatform/cse-customer-support';
import { legacyStrings } from '@leagueplatform/legacy-locales';
import { createReactRouterAdapter } from '@leagueplatform/react-router-adapter';

export const commonCoreConfig = {
  routing: {
    isUsingLeagueRouting: true,
    adapter: createReactRouterAdapter(),
  },
  ui: {
    // theme: leagueTheme,
    // theme: archetypeDarkTheme,
    theme: archetypeLightTheme,
    themeOptions: {
      useRems: true,
      noLegacyTheming: true,
    },
  },
  i18n: {
    strings: { ...legacyStrings, ...customerSupportAppLocales },
  },
};
